export type AttributionStats = {
  Carts: number;
  Customers: number;
  Orders: number;
  TotalRevenue: number;
};

export type FunnelPercentages = {
  addedToCart?: number;
  clicked?: number;
  delivered?: number;
  opened?: number;
  placedOrder?: number;
  purchasedInStore?: number;
};

export enum REVENUE_TYPES {
  ALL_REVENUE = 'AllRevenueAttribution',
  DIRECT_REVENUE = 'DirectAttribution',
  INDIRECT_IN_STORE_REVENUS = 'OpenersInStoreAttribution',
  INDIRECT_ONLINE_REVENUS = 'OpenersOnlineAttribution',
}

export enum CHANNEL_TYPES {
  ALL = 'All',
  EMAIL = 'Email',
  PUSH = 'Push',
  SMS = 'SMS',
}

export const REVENUE_TYPES_FUNNEL = {
  AllRevenueAttribution: ['Delivered', 'Opened', 'ClickedLink', 'Carts', 'PlacedOrder', 'PurchasedInStore'],
  DirectAttribution: ['Delivered', 'Opened', 'ClickedLink', 'Carts', 'PlacedOrder', 'PurchasedInStore'],
  OpenersInStoreAttribution: ['Delivered', 'Opened', 'PurchasedInStore'],
  OpenersOnlineAttribution: ['Delivered', 'Opened', 'PlacedOrder'],
};

export enum DATE_TYPES {
  ONE_DAY = 1,
  THREE_DAYS = 3,
  SEVEN_DAYS = 7,
  FIFTEEN_DAYS = 15,
  THIRTY_DAYS = 30,
}

export const channelDropdownOptions = [
  { label: 'All', id: 'All', value: CHANNEL_TYPES.ALL },
  { label: 'Email', id: 'Email', value: CHANNEL_TYPES.EMAIL },
  { label: 'Push', id: 'Push', value: CHANNEL_TYPES.PUSH },
  { label: 'SMS', id: 'SMS', value: CHANNEL_TYPES.SMS },
];

export const revenueDropdownOptions = [
  { label: 'All revenue', id: 'AllRevenueAttribution' },
  { label: 'Direct revenue', id: 'DirectAttribution' },
  { label: 'Indirect in-store revenue', id: 'OpenersInStoreAttribution' },
  { label: 'Indirect online revenue', id: 'OpenersOnlineAttribution' },
];

export const dateDropdownOptions = [
  { label: '1 day since creation', id: 'oneDay', value: 1 },
  { label: '3 days since creation', id: 'threeDays', value: 3 },
  { label: '7 days since creation', id: 'sevenDays', value: 7 },
  { label: '15 days since creation', id: 'fifteenDays', value: 15 },
  { label: '30 days since creation', id: 'thirtyDays', value: 30 },
];

// we use months for automated campaigns for the values 1, 2, and 3
export const automatedDateDropdownOptions = [
  { label: 'Last 30 days', id: 'thirtyDays', value: 1 },
  { label: 'Last 60 days', id: 'sixtyDays', value: 2 },
  { label: 'Last 90 days', id: 'ninetyDays', value: 3 },
];

export type FilteredChannelDataMap = Record<number, ChannelPerformanceStats>;

export type ChannelPerformanceStats = {
  AllRevenueAttribution?: AttributionStats;
  CampaignDay?: number;
  ClickedLink?: number;
  Delivered?: number;
  DirectAttribution: AttributionStats;
  FailedDeliveries?: number;
  MonthsBack?: number;
  Opened?: number;
  OpenersInStoreAttribution: AttributionStats;
  OpenersOnlineAttribution: AttributionStats;
  Recipients?: number;
  Unsubscribes?: number;
};
